import { render, staticRenderFns } from "./AttachmentsPreview.vue?vue&type=template&id=9e61d090"
import script from "./AttachmentsPreview.vue?vue&type=script&lang=js"
export * from "./AttachmentsPreview.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsPreview.vue?vue&type=style&index=0&id=9e61d090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports